import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  //console.log("Token being sent:", token); // Debugging
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Need to add refresh tokens in future
instance.interceptors.response.use(
  response => response,
  async error => {
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response.data.detail;

      if (errorMessage === "Token has expired") {
        alert("Your session has expired. Please log in again.");
      } else if (errorMessage === "Invalid token") {
        alert("Invalid token. Please log in again.");
      }
      localStorage.removeItem('access_token');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export function apiUrlForPath(path: string | null): string {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  const base = (instance.defaults.baseURL || "").replace(/\/+$/, "");
  const rel = path.replace(/^\/+/, "");
  return base ? `${base}/${rel}` : `/${rel}`;
}

export default instance;
